/** 
  All of the routes for the Material Dashboard 2 React are added here,
  You can add a new route, customize the routes and delete the routes here.

  Once you add a new route on this file it will be visible automatically on
  the Sidenav.

  For adding a new route you can follow the existing routes in the routes array.
  1. The `type` key with the `collapse` value is used for a route.
  2. The `type` key with the `title` value is used for a title inside the Sidenav. 
  3. The `type` key with the `divider` value is used for a divider between Sidenav items.
  4. The `name` key is used for the name of the route on the Sidenav.
  5. The `key` key is used for the key of the route (It will help you with the key prop inside a loop).
  6. The `icon` key is used for the icon of the route on the Sidenav, you have to add a node.
  7. The `collapse` key is used for making a collapsible item on the Sidenav that has other routes
  inside (nested routes), you need to pass the nested routes inside an array as a value for the `collapse` key.
  8. The `route` key is used to store the route location which is used for the react router.
  9. The `href` key is used to store the external links location.
  10. The `title` key is only for the item with the type of `title` and its used for the title text on the Sidenav.
  10. The `component` key is used to store the component of its route.
*/
import React from "react";
import { useNavigate } from "react-router-dom";
import Dashboard from "layouts/dashboard";
import Tables from "layouts/tables";
import Billing from "layouts/billing";
// import RTL from "layouts/rtl";
import Notifications from "layouts/notifications";
import Profile from "layouts/profile";
import SignUp from "layouts/authentication/sign-up";
// Custom Pages
import Areas from "layouts/Areas/Areas";
import Admin from "layouts/Admins/Admins";
import SignIn from "layouts/SignIn/SignIn";
import Tickets from "layouts/Tickets/Tickets";
import SubAdmins from "layouts/SubAdmin/SubAdmins";
import CreateArea from "layouts/Areas/CreateArea/CreateArea";
import CreateAdmin from "layouts/Admins/CreateAdmin/CreateAdmin";
import CreateSubAdmin from "layouts/SubAdmin/CreateSubAdmin/CreateSubAdmin";
import CreateTickets from "layouts/Tickets/CreateTicket/CreateTickets";
import MyProfile from "layouts/profile";
import EditProfile from "layouts/profile/editProfile/editProfile";
import RedirectComponent from "layouts/RedirComp/RedirectComponent";
import ControlPanel from "layouts/ControlPanel/ControlPanel";
import Cameras from "layouts/Cameras/Cameras";

// @mui icons
import Icon from "@mui/material/Icon";
import Devices from "layouts/Devices/Devices";
import CreateDevice from "layouts/Devices/CreateDevice/CreateDevice";
import SmartlightGroups from "layouts/SmartlightGroups/SmartlightGroups";

const useSignOut = () => {
  const navigate = useNavigate();

  const handleSignOut = () => {
    localStorage.clear();

    navigate("/sign-in");
  };

  return handleSignOut;
};
  const redirectToApp = () => {
    const externalURL = "https://app.ivysmartlight.com"; 
    return (
      <a href={externalURL} target="_blank">
        <Icon fontSize="small">camera</Icon> Control Panel
      </a>
    );
  };

const routes = () => {


  const superAdminRoutes = [
    {
      type: "collapse",
      name: "Dashboard",
      key: "dashboard",
      icon: <Icon fontSize="small">dashboard</Icon>,
      route: "/dashboard",
      component: <Dashboard />,
    },
    // {
    //   type: "collapse",
    //   name: "Tables",
    //   key: "tables",
    //   icon: <Icon fontSize="small">table_view</Icon>,
    //   route: "/tables",
    //   component: <Tables />,
    // },
    // {
    //   type: "collapse",
    //   name: "Billing",
    //   key: "billing",
    //   icon: <Icon fontSize="small">receipt_long</Icon>,
    //   route: "/billing",
    //   component: <Billing />,
    // },
    // {
    //   type: "collapse",
    //   name: "RTL",
    //   key: "rtl",
    //   icon: <Icon fontSize="small">format_textdirection_r_to_l</Icon>,
    //   route: "/rtl",
    //   component: <RTL />,
    // },
    // {
    //   type: "collapse",
    //   name: "Notifications",
    //   key: "notifications",
    //   icon: <Icon fontSize="small">notifications</Icon>,
    //   route: "/notifications",
    //   component: <Notifications />,
    // },
    // {
    //   type: "collapse",
    //   name: "Profile",
    //   key: "profile",
    //   icon: <Icon fontSize="small">person</Icon>,
    //   route: "/profile",
    //   component: <Profile />,
    // },
    // {
    //   type: "collapse",
    //   name: "Sign Up",
    //   key: "sign-up",
    //   icon: <Icon fontSize="small">assignment</Icon>,
    //   route: "/authentication/sign-up",
    //   component: <SignUp />,
    // },
    // ADMIN
    {
      type: "collapse",
      name: "Admins",
      key: "admins",
      icon: <Icon fontSize="small">account_circle</Icon>,
      route: "/admins",
      component: <Admin />,
    },
    {
      key: "create_admin",
      route: "/admins/create",
      component: <CreateAdmin />,
    },
        //My Profile
        {
          type: "collapse",
          name: "My Profile",
          key: "MyProfile",
          icon: <Icon fontSize="small">supervisor_account</Icon>,
          route: "/profile",
          component: <MyProfile />,
        },
        {
          key: "edit_password",
          route: "/profile/editpassword",
          component: <EditProfile />,
        },
    // Devices
    {
      type: "collapse",
      name: "Devices",
      key: "devices",
      icon: <Icon fontSize="small">batch_prediction</Icon>,
      route: "/devices",
      component: <Devices />,
    },
    {
      key: "create_device",
      route: "/devices/create",
      component: <CreateDevice />,
    },
    // Tickets
    {
      type: "collapse",
      name: "Tickets",
      key: "tickets",
      icon: <Icon fontSize="small">confirmation_number</Icon>,
      route: "/tickets",
      component: <Tickets />,
    },
    {
      key: "create_ticket",
      route: "/tickets/create",
      component: <CreateTickets />,
    },
    {
      type: "collapse",
      name: "Smartlight Groups",
      key: "smartlight-groups",
      icon: <Icon fontSize="small">group_work</Icon>,
      route: "/smartlight-groups",
      component: <SmartlightGroups />,
    },
    {
      type: "collapse",
      name: "Cameras",
      key: "cameras",
      icon: <Icon fontSize="small">videocam</Icon>,
      route: "/cameras",
      component: <Cameras />,
    },
    {
      type: "collapse",
      name: "Control Panel",
      key: "ControlPanel",
      icon: <Icon fontSize="small">tune</Icon>,
      route: "/control-panel", 
      component: <ControlPanel />,
    }, 
    {
      type: "collapse",
      name: "Sign Out",
      key: "sign-in",
      icon: <Icon fontSize="small">logout</Icon>,
      route: "/sign-in",
      onClick: useSignOut,
      component: <SignIn />,
    },
  ];

  const adminRoutes = [
    {
      type: "collapse",
      name: "Dashboard",
      key: "dashboard",
      icon: <Icon fontSize="small">dashboard</Icon>,
      route: "/dashboard",
      component: <Dashboard />,
    },
    {
      type: "collapse",
      name: "Areas",
      key: "areas",
      icon: <Icon fontSize="small">map</Icon>,
      route: "/areas",
      component: <Areas />,
    },
    {
      key: "create_area",
      route: "/areas/create",
      component: <CreateArea />,
    },
    // Sub Admin
    {
      type: "collapse",
      name: "Sub Admins",
      key: "sub-admins",
      icon: <Icon fontSize="small">supervisor_account</Icon>,
      route: "/sub-admins",
      component: <SubAdmins />,
    },
    {
      key: "create_subAdmin",
      route: "/sub-admins/create",
      component: <CreateSubAdmin />,
    },
    // Devices
    {
      type: "collapse",
      name: "Devices",
      key: "devices",
      icon: <Icon fontSize="small">batch_prediction</Icon>,
      route: "/devices",
      component: <Devices />,
    },
    {
      key: "create_device",
      route: "/devices/create",
      component: <CreateDevice />,
    },
    // Tickets
    {
      type: "collapse",
      name: "Tickets",
      key: "tickets",
      icon: <Icon fontSize="small">confirmation_number</Icon>,
      route: "/tickets",
      component: <Tickets />,
    },
    {
      key: "create_ticket",
      route: "/tickets/create",
      component: <CreateTickets />,
    },
    //My Profile
    {
      type: "collapse",
      name: "My Profile",
      key: "MyProfile",
      icon: <Icon fontSize="small">supervisor_account</Icon>,
      route: "/profile",
      component: <MyProfile />,
    },
    {
      key: "edit_password",
      route: "/profile/editpassword",
      component: <EditProfile />,
    },
    {
      type: "collapse",
      name: "Smartlight Groups",
      key: "smartlight-groups",
      icon: <Icon fontSize="small">group_work</Icon>,
      route: "/smartlight-groups",
      component: <SmartlightGroups />,
    },
    {
      type: "collapse",
      name: "Cameras",
      key: "cameras",
      icon: <Icon fontSize="small">videocam</Icon>,
      route: "/cameras",
      component: <Cameras />,
    },
    {
      type: "collapse",
      name: "Control Panel",
      key: "ControlPanel",
      icon: <Icon fontSize="small">tune</Icon>,
      route: "/control-panel", 
      component: <ControlPanel />,
    },    
    //SignOut
    {
      type: "collapse",
      name: "Sign Out",
      key: "sign-in",
      icon: <Icon fontSize="small">logout</Icon>,
      route: "/sign-in",
      onClick: useSignOut,
      component: <SignIn />,
    },
  ];

  const subAdminRoutes = [
 // AREAS
  // {
  //   type: "collapse",
  //   name: "Areas",
  //   key: "areas",
  //   icon: <Icon fontSize="small">map</Icon>,
  //   route: "/areas",
  //   component: <Areas />,
  // },
  // {
  //   key: "create_area",
  //   route: "/areas/create",
  //   component: <CreateArea />,
  // },
  // Sub Admin
  // {
  //   type: "collapse",
  //   name: "Sub Admins",
  //   key: "sub-admins",
  //   icon: <Icon fontSize="small">supervisor_account</Icon>,
  //   route: "/sub-admins",
  //   component: <SubAdmins />,
  // },
  // {
  //   key: "create_subAdmin",
  //   route: "/sub-admins/create",
  //   component: <CreateSubAdmin />,
  // },
  // Devices
  {
    type: "collapse",
    name: "Devices",
    key: "devices",
    icon: <Icon fontSize="small">batch_prediction</Icon>,
    route: "/devices",
    component: <Devices />,
  },
  {
    key: "create_device",
    route: "/devices/create",
    component: <CreateDevice />,
  },
      //My Profile
      {
        type: "collapse",
        name: "My Profile",
        key: "MyProfile",
        icon: <Icon fontSize="small">supervisor_account</Icon>,
        route: "/profile",
        component: <MyProfile />,
      },
      {
        key: "edit_password",
        route: "/profile/editpassword",
        component: <EditProfile />,
      },
  // Tickets
  {
    type: "collapse",
    name: "Tickets",
    key: "tickets",
    icon: <Icon fontSize="small">confirmation_number</Icon>,
    route: "/tickets",
    component: <Tickets />,
  },
  {
    key: "create_ticket",
    route: "/tickets/create",
    component: <CreateTickets />,
  },
  {
    type: "collapse",
    name: "Cameras",
    key: "cameras",
    icon: <Icon fontSize="small">videocam</Icon>,
    route: "/cameras",
    component: <Cameras />,
  },
  {
    type: "collapse",
    name: "Control Panel",
    key: "ControlPanel",
    icon: <Icon fontSize="small">tune</Icon>,
    route: "/control-panel", 
    component: <ControlPanel />,
  }, 
  {
    type: "collapse",
    name: "Sign Out",
    key: "sign-in",
    icon: <Icon fontSize="small">assignment</Icon>,
    route: "/sign-in",
    onClick: useSignOut,
    component: <SignIn />,
  },
];

  const notLoggedInRoutes = [
    // Sign In
    {
      // type: "collapse",
      // name: "Sign In",
      // icon: <Icon fontSize="small">login</Icon>,
      key: "sign-in",
      route: "/sign-in",
      component: <SignIn />,
    },
  ];

  return {
    superAdminRoutes,
    adminRoutes,
    subAdminRoutes,
    notLoggedInRoutes,
  };
}

export default routes;